import InsideSalesFiltersByPeriod from './InsideSalesFiltersByPeriod';

export default InsideSalesFiltersByPeriod;
